import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme => ({
  tabsWrapper: {
    flex: '0 1 220px', 
    [theme.breakpoints.down('sm')]:{
      flex: '0 1 300px',
    }
  },

  root: {
    padding: '18px 30px',
    borderBottom: '1px solid #E2EBF6',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]:{
     
    }
  },

  wrapper: {
    alignItems: 'flex-start'
  },

  selected: {
    backgroundColor: '#E2F5F8',
    color: '#071B27 !important'
  },

  textColorInherit: {
    opacity: 1,
    color: '#335267'
  }
})));

export default useStyles;
